<i-title
  level="1"
  class="mt-3"
  [text]="'statements.title' | translate"
></i-title>

<div class="card my-3">
  <div class="card-body">
    <div class="row g-3">
      <!-- Filtres de texte -->
      <div class="col-md-3">
        <label for="plate" class="form-label">{{
          "statements.plate" | translate
        }}</label>
        <span class="p-input-icon-left w-100">
          <i class="bi bi-aspect-ratio"></i>
          <input
            id="plate"
            type="text"
            pInputText
            class="form-control"
            [(ngModel)]="filters.plate"
            (ngModelChange)="onFilterChangeWithDebounce()"
            [placeholder]="'statements.plate' | translate"
          />
        </span>
      </div>
      <div class="col-md-3">
        <label for="brand" class="form-label">{{
          "statements.brand" | translate
        }}</label>
        <span class="p-input-icon-left w-100">
          <i class="pi pi-car"></i>
          <input
            id="brand"
            type="text"
            pInputText
            class="form-control"
            [(ngModel)]="filters.brand"
            (ngModelChange)="onFilterChangeWithDebounce()"
            [placeholder]="'statements.brand' | translate"
          />
        </span>
      </div>

      <!-- Filtres de date -->
      <div class="col-md-3">
        <label for="startDate" class="form-label">{{
          "statements.startDate" | translate
        }}</label>
        <p-calendar
          id="startDate"
          [(ngModel)]="filters.startDate"
          (ngModelChange)="onStartDateChange($event)"
          [showIcon]="true"
          [showTime]="true"
          dateFormat="dd/mm/yy"
          [placeholder]="'statements.startDate' | translate"
          class="w-100"
          styleClass="w-100"
        ></p-calendar>
      </div>
      <div class="col-md-3">
        <label for="endDate" class="form-label">{{
          "statements.endDate" | translate
        }}</label>
        <p-calendar
          id="endDate"
          [(ngModel)]="filters.endDate"
          (ngModelChange)="onFilterChangeImmediate()"
          [showIcon]="true"
          [showTime]="true"
          dateFormat="dd/mm/yy"
          [placeholder]="'statements.endDate' | translate"
          [minDate]="minEndDate"
          class="w-100"
          styleClass="w-100"
        ></p-calendar>
      </div>

      <!-- Deuxième ligne -->
      <div class="col-md-3">
        <label for="interventionType" class="form-label">{{
          "statements.interventionType" | translate
        }}</label>
        <p-dropdown
          id="interventionType"
          [options]="interventionTypes"
          [(ngModel)]="filters.interventiontypeid"
          (ngModelChange)="onFilterChangeImmediate()"
          [placeholder]="'statements.all_types' | translate"
          [showClear]="true"
          class="w-100"
          styleClass="w-100"
          [autoDisplayFirst]="false"
          optionLabel="description"
          optionValue="id"
        ></p-dropdown>
      </div>

      <div class="col-md-3">
        <label for="towingType" class="form-label">{{
          "statements.towingType" | translate
        }}</label>
        <p-dropdown
          id="towingType"
          [options]="towingTypes"
          [(ngModel)]="filters.towingtypeid"
          (ngModelChange)="onFilterChangeImmediate()"
          [placeholder]="'statements.all_types' | translate"
          [showClear]="true"
          class="w-100"
          styleClass="w-100"
          [autoDisplayFirst]="false"
          optionLabel="description"
          optionValue="id"
        ></p-dropdown>
      </div>

      <!-- Bouton de réinitialisation -->
      <div
        class="offset-md-3 col-md-3 d-flex align-items-end justify-content-end"
      >
        <button
          pButton
          icon="pi pi-filter-slash"
          (click)="clearFilters()"
          class="p-button-outlined"
          [label]="'statements.clearFilters' | translate"
        ></button>
      </div>
    </div>
  </div>
</div>

<div class="d-flex justify-content-between mb-3 gap-2">
  <button
    pButton
    icon="pi pi-refresh"
    class="p-button-outlined"
    [label]="'statements.refresh' | translate"
    (click)="refreshStatements()"
    [loading]="loading"
  ></button>
  <button
    pButton
    icon="pi pi-file-excel"
    class="p-button-success"
    [label]="'statements.exportExcel' | translate"
    (click)="exportToExcel()"
  ></button>
</div>

<div class="p-1 mb-3">
  <p-table
    #table
    class="i-table-v2"
    [value]="statements"
    [loading]="loading"
    [tableStyle]="{ 'min-width': '50rem' }"
    styleClass="p-datatable-striped"
    [scrollable]="true"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [paginator]="true"
    [showFirstLastIcon]="true"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[5, 10, 25, 50]"
    [currentPageReportTemplate]="'statements.pageReport' | translate"
    [first]="first"
    [lazy]="true"
    (onPage)="onPageChange($event)"
  >
    <ng-template pTemplate="header">
      <tr>
        <th scope="col">{{ "statements.plate" | translate }}</th>
        <th scope="col">{{ "statements.brand" | translate }}</th>
        <th scope="col">{{ "statements.model" | translate }}</th>
        <th scope="col">{{ "statements.towingDate" | translate }}</th>
        <th scope="col">{{ "statements.interventionType" | translate }}</th>
        <th scope="col">{{ "statements.towingType" | translate }}</th>
        <th scope="col">{{ "statements.address" | translate }}</th>
        <th scope="col" alignFrozen="right" pFrozenColumn [frozen]="true"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-statement>
      <tr>
        <td [class.be]="isCountryBelgium(statement.country)">
          {{ statement.plate }}
        </td>
        <td>{{ statement.brand }}</td>
        <td>{{ statement.model }}</td>
        <td>{{ statement.towingDate | date : "dd/MM/yyyy HH:mm" }}</td>
        <td>{{ statement.interventionType }}</td>
        <td>{{ statement.towingType }}</td>
        <td>
          {{ statement.street }}, {{ statement.postalCode }}
          {{ statement.city }}
        </td>
        <td alignFrozen="right" pFrozenColumn [frozen]="true">
          <button
            pButton
            icon="bi bi-three-dots"
            class="p-button-rounded p-button-info p-button-sm mr-2"
            [pTooltip]="'statements.view_details' | translate"
            tooltipPosition="left"
            (click)="viewDetails(statement)"
          ></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9" class="text-center">
          {{ "statements.no_data" | translate }}
        </td>
      </tr> </ng-template
    ><ng-template pTemplate="loadingbody">
      <tr *ngFor="let item of skeletonRows">
        <td><p-skeleton></p-skeleton></td>
        <td><p-skeleton></p-skeleton></td>
        <td><p-skeleton></p-skeleton></td>
        <td><p-skeleton></p-skeleton></td>
        <td><p-skeleton></p-skeleton></td>
        <td><p-skeleton></p-skeleton></td>
        <td><p-skeleton></p-skeleton></td>
        <td><p-skeleton></p-skeleton></td>
        <td><p-skeleton shape="circle" size="2rem"></p-skeleton></td>
      </tr>
    </ng-template>
  </p-table>
</div>
